import * as React from 'react';
import { Field } from 'redux-form';
import { jsx as _jsx } from "react/jsx-runtime";
const FormField = props =>
/*#__PURE__*/
// $FlowFixMe[incompatible-type]
// $FlowFixMe[incompatible-exact]
// $FlowFixMe[prop-missing]
// $FlowFixMe[sketchy-null-string]
_jsx(Field, {
  id: props.id || props.name,
  ...props
});
export default FormField;